import { lazy } from 'react';
const ApisPage = lazy(() => import('@/pages/apis/ApisPage'));
const CaseDetails = lazy(() => import('@/pages/case-details/CaseDetails'));
const CasesPage = lazy(() => import('@/pages/cases/CasesPage'));
const ClientDashboard = lazy(() => import('@/pages/client/ClientDashboard'));
const CompanyDashboardPage = lazy(
  () => import('@/pages/company/CompanyDashboardPage'),
);
const CompanyList = lazy(() => import('@/pages/company/CompanyList'));
const CriticalTask = lazy(
  () => import('@/pages/critical-task/components/CriticalTask'),
);
const CriticalTasksPage = lazy(
  () => import('@/pages/critical-task/CriticalTasksPage'),
);
const Dashboard = lazy(() => import('@/pages/dashboard/Dashboard'));
const InsuffPage = lazy(() => import('@/pages/insufficience-cases/InsuffPage'));
const Profile = lazy(() => import('@/pages/profile/Profile'));
const TasksPage = lazy(() => import('@/pages/tasks/TasksPage'));
const TatPriorityPage = lazy(
  () => import('@/pages/tat-priority/TatPriorityPage'),
);
const TeamPage = lazy(() => import('@/pages/team/TeamPage'));
const ActivitiesPage = lazy(() => import('@/pages/Activities/Activities'));
const CaseActivityPage = lazy(
  () => import('@/pages/client/case-activity/CaseActivityPage'),
);
const VEDashboard = lazy(
  () => import('@/pages/verification-executive/VEDashboard'),
);
const UanList = lazy(() => import('@/pages/uan-request/UanList'));
const VendorDashboard = lazy(() => import('@/pages/vendor/VendorDashboard'));
const ClientCasesPage = lazy(
  () => import('@/pages/client/client-cases/ClientCasesPage'),
);
const SubCompanies = lazy(() => import('@/pages/sub-companies/SubCompanies'));
const BulkCases = lazy(() => import('@/pages/bulk-cases/BulkCases'));
const AssignedCase = lazy(
  () => import('@/pages/vendor/Components/AssignedCase'),
);
const SubCompanyDashboard = lazy(
  () => import('@/pages/sub-companies/components/SubCompanyDashboard'),
);
const SubCompanyCaseDetails = lazy(
  () => import('@/pages/sub-companies/components/SubCompanyCaseDetails'),
);
const VkycPage = lazy(() => import('@/pages/vkyc/VkycPage'));
const VkycDetailsPage = lazy(() => import('@/pages/vkyc/VkycDetailsPage'));
const ProductPage = lazy(() => import('@/pages/product/ProductPage'));
const FileDownload = lazy(() => import('@/pages/DownloadFile/FileDownload'));

export const getAdminRoutes = () => {
  const userData = JSON.parse(localStorage.getItem('user'));

  if (!userData) return [];

  const { user, claims, company, isSuperAdmin } = userData;

  const allRoutes = [
    {
      index: true,
      path: '/',
      element: <Dashboard />,
      claims: ['access_dashboard'],
    },
    {
      index: true,
      path: '/',
      element: <VEDashboard />,
      claims: ['access_task_dashboard'],
    },
    {
      path: '/cases',
      element: <CasesPage />,
      claims: ['create_cases', 'read_cases', 'manage_cases'],
    },
    { path: '/profile', element: <Profile /> },
    { path: '/bulk-cases', element: <BulkCases /> },
    {
      path: 'case-details/:id',
      element: <CaseDetails />,
      claims: ['manage_cases', 'read_cases'],
    },
    {
      path: '/sub-companies/:subCompanyId/case-details/:id',
      element: <SubCompanyCaseDetails />,
      claims: ['client_claims'],
    },
    {
      path: '/companies',
      element: <CompanyList />,
      claims: ['create_companies', 'manage_companies'],
    },
    {
      path: '/companies/:id',
      element: <CompanyDashboardPage />,
      claims: ['manage_companies', 'create_companies'],
    },
    {
      path: '/companies/:companyId/sub-companies/:subCompanyId',
      element: <SubCompanyDashboard />,
      claims: ['manage_companies', 'create_companies'],
    },

    {
      path: '/',
      element: <ClientDashboard />,
      claims: ['client_claims'], // Added this for company users
    },
    {
      path: '/sub-companies',
      element: <SubCompanies />,
      claims: ['client_claims'],
    },

    {
      path: '/tat-priority',
      element: <TatPriorityPage />,
      claims: ['access_dashboard'],
    },
    {
      path: '/team',
      element: <TeamPage />,
      claims: ['read_users', 'create_user', 'manage_users'],
    },
    {
      path: '/insufficiency',
      element: <InsuffPage />,
      claims: ['manage_insufficiencies', 'resolve_insufficiencies'],
    },
    {
      path: '/tasks',
      element: <TasksPage />,
      claims: ['create_tasks', 'manage_tasks'],
    },
    {
      path: '/critical-task',
      element: <CriticalTasksPage />,
      claims: ['read_tasks'],
    },
    {
      path: '/critical-task/:id',
      element: <CriticalTask />,
      claims: ['read_tasks'],
    },
    {
      path: '/activities',
      element: <ActivitiesPage />,
    },
    {
      path: '/apis',
      element: <ApisPage />,
      claims: ['access_api_catalog'],
    },
    {
      path: '/case-activity',
      element: <CaseActivityPage />,
      claims: ['client_claims'], // Added this for company users
    },
    {
      path: '/client-cases',
      element: <ClientCasesPage />,
      claims: ['client_claims'],
    },
    {
      path: '/uan-request',
      element: <UanList />,
      claims: ['access_uan_requests'],
    },
    {
      path: '/vendor',
      element: <VendorDashboard />,
      claims: ['vendor'],
    },
    {
      path: '/assigned-case/:id',
      element: <AssignedCase />,
      claims: ['vendor'],
    },
    {
      path: '/imposter-check',
      element: <VkycPage />,
    },
    {
      path: '/imposter-check/details/:id',
      element: <VkycDetailsPage />,
    },
    {
      path: '/products',
      element: <ProductPage />,
    },
    {
      path: '/public/files/:keyId',
      element: <FileDownload />,
    },
  ];

  if (user?.entityType === 'Company') {
    return allRoutes
      .map((route) =>
        route.path === '/' ? { ...route, element: <ClientDashboard /> } : route,
      )
      .filter((route) => {
        // If user is not a super admin, only allow imposter check routes and profile
        if (!isSuperAdmin) {
          return (
            route.path === '/imposter-check' ||
            route.path === '/imposter-check/details/:id'
            // route.path === '/profile' ||
          );
        }

        // If user is a super admin, allow all routes in alwaysAllowedPaths
        const alwaysAllowedPaths = [
          '/',
          '/case-activity',
          'case-details/:id',
          '/companies/:id',
          '/profile',
          '/bulk-cases',
          '/activities',
          '/client-cases',
          '/companies/:companyId/sub-companies/:subCompanyId',
          '/sub-companies/:subCompanyId/case-details/:id',
          '/products',
          '/public/files/:keyId',
          '/imposter-check',
          '/imposter-check/details/:id',
        ];

        if (route.path === '/team') {
          return company?.bcaId?.configurations?.allowRoleForCompany === true;
        }
        // Include /sub-companies only if company.isSubCompany is true
        if (route.path === '/sub-companies') {
          return !company?.isSubCompany && company?.allowSubCompany;
        }
        // Include /team only if company.bcaId.configurations.allowRoleForCompany is true
        if (route.path === '/team') {
          return company?.bcaId?.configurations?.allowRoleForCompany === true;
        }

        return alwaysAllowedPaths.includes(route.path);
      });
  }

  if (user?.entityType === 'Vendor') {
    return allRoutes
      .map((route) =>
        route.path === '/vendor'
          ? { ...route, element: <VendorDashboard /> }
          : route,
      )
      .filter((route) =>
        ['/vendor', '/assigned-case/:id'].includes(route.path),
      );
  }
  return allRoutes.filter(
    (route) =>
      !route?.claims || route?.claims?.some((claim) => claims?.includes(claim)),
  );
};
